import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { RecordInfoModel } from '@/types/Component';
import { toCamel } from 'snake-camel';
import moment from 'moment';
import { LoginUser, ShippingRecordHarvestRecord } from "@/types/Component";
import ShippingRecordModal from '@/assets/common/Modal/ShippingRecordModal/ShippingRecordModal.vue';
import HarvestRecordModal from '@/assets/common/Modal/HarvestRecordModal/HarvestRecordModal.vue'

export type HarvestRecordItem = {
    harvestDate: string;
    planting: {
        id: string;
        name: string;
    };
    crop: {
        id: string;
        name: string;
        phonetic: string;
    };
    agriField: {
        id: string;
        name: string;
        plantedArea: number;
    };
    harvestRecordData: HarvestRecordData[];
    measurementTimingId: string;
    measurementTimingName: string;
    lotNumber: string | null;
    fileId: string[];
    memo: string | null;
    isEditable: boolean;
} & RecordInfoModel;

export type HarvestRecordData = {
    qualityStandardId: string;
    qualityStandardName: string;
    quantity: number | null;
    remainingQuantity: number | null;
    weightUnitId: string | null;
    weightUnitName: string;
    weightPerUnit: number | null;
};

export type ShippingDetail = {
    harvestDate: string;
    quantity: number;
    weightUnitId: string | null;
    weightPerUnit: number | null;
};

export type ShippingDestinationDetail = {
    id: string;
    shippingRecordId: string;
    shippingDate: string;
    shippingDestinationName: string;
    classification: string;
    quantity: number;
    weightUnitId: string | null;
    weightPerUnit: number | null;
    weightUnitName: string;
    shippingDetails: ShippingDetail[];
    memo: string | null;
    quantityInKg: number | string;
};

export type ShippingRecordData = {
    remainingQuantity: number | null;
    shippingDestinationDetails: ShippingDestinationDetail[];
};

@Component({
    components: {
        ShippingRecordModal,
        HarvestRecordModal
    }
})
export default class HarvestDetailModal extends Vue {
    private shippingMode = '';
    private isShippingModalShow = false
    private isRefreshHarvest = false;
    private selectedHarvestId :any ='';
    private mode = '';
    private harvestMode = '';
    private isShow = false
    private isHarvestShow = false
    private selectedShippingRecordId :string | null = null
    private harvestRecordToShippingModel: ShippingRecordHarvestRecord[] = []
    private isDisplay = '';
    private isUnLinkClicked = false;

    get isAdmin(): boolean {
        return this.loginUser.role.find((r: string) => {
            return r === 'ADMIN'
        }) !== undefined;
      }
    
    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }    

    @Prop({ default: false })
     isRefresh!: boolean;

    @Prop({ default: false })
    showHarvestDetailModal!: boolean;

    @Prop()
    id?: string

    harvestRecord: HarvestRecordItem | null = null
    selectedQualityIndex: number | null = null
    selectedQualityId: string | null = null
    shippingRecords: ShippingRecordData | null = null
    remainingQuantity: number | null = null
    totalShippingByUnit: number | null = null
    totalShippingUnit: string | null = null
    totalShippingByKg: number | null = null
    loading = false;

    closeModal() {
        this.harvestRecord = null;
        this.setNull();
        if(this.isRefresh === true){
            this.$emit('update:isRefresh', true);
        }
        this.$emit('update:showHarvestDetailModal', false);
    }

    setNull () {
        this.selectedQualityIndex = null;
        this.selectedQualityId = null;
        this.shippingRecords = null;
        this.totalShippingByUnit = null;
        this.totalShippingUnit = null;
        this.totalShippingByKg = null;
        this.remainingQuantity = null;
    }

    @Watch("showHarvestDetailModal")
    handleModal() {
        this.harvestRecord = null;
        if (this.id) {
            this.getHarvestRecord();
        }
    }

    getHarvestRecord() {
        this.loading = true;
        this.$apiClient.doRequest('get', '/harvest_records/' + this.id).then(res => {
            this.isDisplay = res.display_flag
            this.harvestRecord = toCamel(this.reduceHarvestData(res)) as HarvestRecordItem;
            const index = this.selectedQualityIndex ? this.selectedQualityIndex : 0;
            const id = this.selectedQualityId ? this.selectedQualityId : this.harvestRecord?.harvestRecordData[0]?.qualityStandardId;
            this.selectQuality(index, id);
        }).catch(() => {
            this.$toasted.error('データの取得に失敗しました。');
            this.loading = false;
        })
    }

    reduceHarvestData(data: { harvest_record_data: any[] }): any {
        const reducedData: { [key: string]: any } = {};
        data.harvest_record_data.sort((a, b) => a.quality_standard_name.localeCompare(b.quality_standard_name)).forEach((record: any) => {
            const key = `${record.quality_standard_id}-${record.weight_unit_id || ''}`;
            if (!reducedData[key]) {
                reducedData[key] = {
                    quality_standard_id: record.quality_standard_id,
                    quality_standard_name: record.quality_standard_name,
                    weight_unit_id: record.weight_unit_id,
                    weight_unit_name: record.weight_unit_name,
                    weight_per_unit: record.weight_per_unit,
                    quantity: record.quantity,
                    remaining_quantity: record.remaining_quantity
                };
            } else {
                if (record.quantity !== null) {
                    reducedData[key].quantity += record.quantity;
                }
                if (record.remaining_quantity !== null) {
                    reducedData[key].remaining_quantity += record.remaining_quantity;
                }
            }
        });
        data.harvest_record_data = Object.values(reducedData);
        return data;
    }

    selectQuality(index: number, id : string) {
        this.loading = true;
        this.isUnLinkClicked = false;
        this.setNull();
        if (this.id !== null && id !== null && id !== undefined) {
            this.selectedQualityIndex = index;
            this.selectedQualityId = id;
            this.$apiClient.doRequest('get', '/admin/shipping_records/' + this.id + '/' + id).then(res => {
                const data = toCamel(res) as ShippingRecordData;
                this.remainingQuantity = data.remainingQuantity;
                if (data.shippingDestinationDetails.length > 0) {
                    data.shippingDestinationDetails.forEach((obj) => {
                        const weightPerUnit = obj.weightUnitId !== null ? obj.weightPerUnit : 1;
                        obj.quantityInKg = weightPerUnit !== null ? obj.quantity * weightPerUnit : "単位未設定";
                    });
                    this.shippingRecords = data;
                    this.totalShippingByUnit = this.sumShippingQuantityByUnit(data);
                    this.totalShippingByKg = this.sumShippingQuantityByKg(data);
                }
                this.loading = false;
            }).catch(() => {
                this.$toasted.error('データの取得に失敗しました。');
                this.loading = false;
            })
        }
    }

    selectUnlinkedQuantity(){
        this.loading = true;
        this.shippingRecords = null;
        this.isUnLinkClicked = true;
        this.$apiClient.doRequest('get', '/admin/shipping_records/' + this.id + '/qualityStandardId').then(res => {
            const data = toCamel(res) as ShippingRecordData;
            this.remainingQuantity = data.remainingQuantity;
            if (data.shippingDestinationDetails.length > 0) {
                data.shippingDestinationDetails.forEach((obj) => {
                    const weightPerUnit = obj.weightUnitId !== null ? obj.weightPerUnit : 1;
                    obj.quantityInKg = weightPerUnit !== null ? obj.quantity * weightPerUnit : "単位未設定";
                });
                this.shippingRecords = data;
                this.totalShippingByUnit = this.sumShippingQuantityByUnit(data);
                this.totalShippingByKg = this.sumShippingQuantityByKg(data);
            }
            this.loading = false;
        }).catch(() => {
            this.$toasted.error('データの取得に失敗しました。');
            this.loading = false;
        })
    }

    sumShippingQuantityByKg(shippingItems: ShippingRecordData): number | null {
        const valid = !shippingItems.shippingDestinationDetails.some(item => item.quantityInKg === '単位未設定');
        return valid ?
            shippingItems.shippingDestinationDetails.reduce((total, item) => {
                if (typeof item.quantityInKg === 'number') {
                    return total + item.quantityInKg;
                } else {
                    return total;
                }
            }, 0) :
            null;
    }

    sumShippingQuantityByUnit(shippingItems: ShippingRecordData): number | null {
        const uniqueWeightUnitIds = new Set(shippingItems.shippingDestinationDetails.map(item => item.weightUnitId));
        this.totalShippingUnit = uniqueWeightUnitIds.size <= 1 ? shippingItems.shippingDestinationDetails[0].weightUnitName : null;
        return uniqueWeightUnitIds.size <= 1 ? 
            shippingItems.shippingDestinationDetails.reduce((total, item) => total + item.quantity, 0) : 
            null;
    }

    formatDate(date: string) {
        return moment(date).format('YYYY/MM/DD')
    }

    calculateInKg(quantity: number | null, weightUnitId: string | null, weightPerUnit: number | null): number | string {
        if (weightUnitId === null) {
            return quantity !== null ? `${this.formatDigit(quantity)}kg` : '---';
        } else if (weightPerUnit !== null && quantity !== null) {
            return this.formatDigit(quantity * weightPerUnit) + 'kg';
        } else {
            return quantity !== null ? '単位未設定' : '---';
        }
    }

    formatDigit(numberToFormat?: number): string {
        return typeof numberToFormat === 'number' ? 
        numberToFormat.toLocaleString(undefined, {
            minimumFractionDigits: (numberToFormat % 1 !== 0) ? 2 : 0,
            maximumFractionDigits: (numberToFormat % 1 !== 0) ? 2 : 0
        }) 
        : '';
    }

    openShippingRecordModal(id = null, shippingMode = '') {
        if (id == null && shippingMode == 'new' && this.id && this.harvestRecord) {
            const data: ShippingRecordHarvestRecord = {
                id: this.id,
                harvestDate: this.harvestRecord.harvestDate,
                measurementTimingId: this.harvestRecord.measurementTimingId,
                planting: {
                    id: this.harvestRecord.planting.id,
                    name: this.harvestRecord.planting.name,
                },
                agriField: {
                    id: this.harvestRecord.agriField.id,
                    name: this.harvestRecord.agriField.name,
                },
                qualityData:''
            };
            this.harvestRecordToShippingModel.push(data);
        }
        this.selectedShippingRecordId = id;
        this.shippingMode = shippingMode;
        this.isShippingModalShow = true;
    }
    closeShippingRecordModal() {
        this.selectedShippingRecordId = null;
        this.harvestRecordToShippingModel = [];
        this.shippingMode = ''
        this.isShippingModalShow = false;
    }

    refreshHarvestDetail () {
        this.loading = true
        this.isRefresh =true
        if(this.isUnLinkClicked==true){
            this.selectUnlinkedQuantity();
        }else{
            this.getHarvestRecord();
        }
    }

    processShippingDetail(data: ShippingDetail[]) {
        const detail: string[] = [];
        data.forEach(item => {
            const formattedDate = this.formatDate(item.harvestDate);
            let weight = '';
            if (item.weightUnitId === null) {
                weight = `${this.formatDigit(item.quantity)}kg`;
            } else if (item.weightPerUnit !== null) {
                weight = this.formatDigit(item.quantity * item.weightPerUnit) + 'kg';
            } else {
                weight = `<span style="color: red;" class="tooltip">単位未設定</span>`;
            }
            detail.push(`${formattedDate} ${weight}`);
        });
        return detail;
    }
    openHarvestPopUpModal() {
        this.isShow = true;
        this.selectedHarvestId = this.id;
        this.mode = 'edit';
    }
    closeHarvestModal() {
        this.selectedHarvestId = null;
        this.mode = ''
        this.isShow = false;
    }
}